import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram } from 'lucide-react'
import Logo from '../ui/Logo'

const Footer: React.FC = () => {
  const { t } = useTranslation()
  const { lang } = useParams<{ lang: string }>()
  
  // Validate language parameter - only allow valid language codes
  const validLanguages = ['en', 'fr', 'ar']
  const currentLang = lang && validLanguages.includes(lang) ? lang : 'en'

  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Logo size="lg" />
            <p className="text-sm text-muted-foreground max-w-xs">
              {t('companyDescription')}
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-muted-foreground hover:text-brand-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-brand-600 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-brand-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">{t('quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to={`/${currentLang}`}
                  className="text-sm text-muted-foreground hover:text-brand-500 transition-colors"
                >
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${currentLang}/cars`}
                  className="text-sm text-muted-foreground hover:text-brand-500 transition-colors"
                >
                  {t('common:cars')}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${currentLang}/agencies`}
                  className="text-sm text-muted-foreground hover:text-brand-500 transition-colors"
                >
                  {t('agencies')}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${currentLang}/about`}
                  className="text-sm text-muted-foreground hover:text-brand-500 transition-colors"
                >
                  {t('about')}
                </Link>
              </li>
            </ul>
          </div>

          {/* For Agencies */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">{t('forAgencies')}</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to={`/${currentLang}/signup`}
                  className="text-sm text-muted-foreground hover:text-brand-500 transition-colors"
                >
                  {t('joinAsAgency')}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${currentLang}/terms`}
                  className="text-sm text-muted-foreground hover:text-brand-500 transition-colors"
                >
                  {t('termsOfService')}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${currentLang}/privacy`}
                  className="text-sm text-muted-foreground hover:text-brand-500 transition-colors"
                >
                  {t('privacyPolicy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">{t('contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-muted-foreground" />
                <span className="text-sm text-muted-foreground">info@kiracar.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-muted-foreground" />
                <span className="text-sm text-muted-foreground">07 85 83 36 35</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-muted-foreground mt-0.5" />
                <span className="text-sm text-muted-foreground">
                  RUE ALLAL BEN ABDELLAH N 70 1ERE ETAGE APPT 2,<br />
                  Rich 52400, Midelt
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center">
          <div className="space-y-2">
            <p className="text-sm text-muted-foreground">
              © 2025 KiraCar. {t('allRightsReserved')}.
            </p>
            <p className="text-xs text-muted-foreground">
              KiraCar {t('poweredByRichaDev')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 